/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import mutations from '@/store/modules/ui/mutations'
import { EventBus } from '@/helpers'

// RIGHT NAVIGATION
mutations.setRightActiveComponent = (state, rightActiveComponent) => {
  if (rightActiveComponent && !rightActiveComponent.component) {
    state.rightNavHistory = []
  }
  state.rightActiveComponent = rightActiveComponent
}

mutations.pushRightNavHistory = (state, value) => {
  state.rightNavHistory.push(value)
}

mutations.popRightNavHistory = (state) => {
  state.rightNavHistory.pop()
}

mutations.setShowRightLoader = (state, status) => {
  state.showRightLoader = status
}

mutations.showSearch = (state, show) => {
  /* emit change of search */
  EventBus.$emit('quickView:change', show)
  state.showSearch = show
}

// LEFT NAVIGATION
mutations.setLeftActiveComponent = (state, leftActiveComponent) => {
  if (leftActiveComponent && !leftActiveComponent.component) {
    state.leftNavHistory = []
  }
  state.leftActiveComponent = leftActiveComponent
}

mutations.pushLeftNavHistory = (state, value) => {
  state.leftNavHistory.push(value)
}

mutations.popLeftNavHistory = (state) => {
  state.leftNavHistory.pop()
}

mutations.setShowLeftLoader = (state, status) => {
  state.showLeftLoader = status
}

// TOP NAVIGATION
mutations.setTopActiveComponent = (state, topActiveComponent) => {
  if (topActiveComponent && !topActiveComponent.component) {
    state.topNavHistory = []
  }
  state.topActiveComponent = topActiveComponent
}

mutations.pushTopNavHistory = (state, value) => {
  state.topNavHistory.push(value)
}

mutations.popTopNavHistory = (state) => {
  state.topNavHistory.pop()
}

mutations.setShowTopLoader = (state, status) => {
  state.showTopLoader = status
}

// BOTTOM NAVIGATION
mutations.setBottomActiveComponent = (state, bottomActiveComponent) => {
  if (bottomActiveComponent && !bottomActiveComponent.component) {
    state.bottomNavHistory = []
  }
  state.bottomActiveComponent = bottomActiveComponent
}

mutations.pushBottomNavHistory = (state, value) => {
  state.bottomNavHistory.push(value)
}

mutations.popBottomNavHistory = (state) => {
  state.bottomNavHistory.pop()
}

mutations.setShowBottomLoader = (state, status) => {
  state.showBottomLoader = status
}

// SUBMENU NAVIGATION
mutations.setSubMenuActiveComponent = (state, subMenuActiveComponent) => {
  if (subMenuActiveComponent && !subMenuActiveComponent.component) {
    state.subMenuHistory = []
  }
  state.subMenuActiveComponent = subMenuActiveComponent
}

mutations.pushSubMenuHistory = (state, value) => {
  state.subMenuHistory.push(value)
}

mutations.popSubMenuHistory = (state) => {
  state.topNavHistory.pop()
}

mutations.setShowSubMenuLoader = (state, status) => {
  state.showSubMenuLoader = status
}

mutations.setBodyClass = (state, classes) => {
  state.bodyClass = classes
}

// HEADER LOGIC
mutations.heroAttributes = (state, attributes) => {
  state.isHero = attributes.isHero
  state.headerHeight = attributes.headerHeight
}

// PAGE HEADER TITLE
mutations.setHeaderPageTitle = (state, title) => {
  state.headerPageTitle = title
}

// GENERIC MODAL
mutations.setGenericModalComponent = (state, { title, componentToRender, modalProps }) => {
  state.genericModalComponent = {
    title,
    componentToRender,
    modalProps
  }
}

mutations.setRouterRefresh = (state, boolVal) => {
  state.routerRefresh = boolVal
}

export default {
  ...mutations
}
